/**
 * 保存確認モーダルのボタン処理
 *
 * @param {number} move_function        移動先番号
 * @param {string} move_company_id      移動先企業ID
 * @param {string} move_organization_id 移動先店舗ID
 * @param {string} move_view_date       移動先日付（年月/年月日）
 * @param {object} $clicked_object      クリックされた要素
 * @author hayakawa 2023.10.20
 */

// インポート
import {
    move_no_setting_change_company, move_no_setting_change_organization,
    move_no_predict_change_company, move_no_predict_change_organization, move_no_predict_change_ym,
    move_no_shift, move_no_monthly, move_no_weekly, move_no_dayly,
    move_no_dayly_change_company, move_no_dayly_change_organization, move_no_dayly_change_ymd, move_no_dayly_change_type
} from './_constants';
import { movePagefromModal } from './move_page_from_modal';
import { submitCompany, submitOrganization, submitEmployee } from './Master/_functions';
import { saveDefaultShift, saveSettingOthers } from './Setting/_functions';
import { savePredict } from './Predict/_functions';
import { setShiftAll } from './Shift/_functions';

// 定数
const PATH_NAME = location.pathname,
    $modal_unlock_view_mode = $('#modal-unlock-view-mode');

// 処理
$(function() {
    // 保存して移動
    $('#btn-save-data').on('click', function() {
        $('#modal-check-move-page').modal('hide');
        if ($(this).hasClass('is-view-mode')) {
            $clicked_object = $(this);
            $modal_unlock_view_mode.find('[name="unlock_code"]').val('');
            $modal_unlock_view_mode.modal('show');
        } else {
            // 企業追加
            if (PATH_NAME.includes('Master/Company/create')) {
                $('#form-store-company').find('[name=move_function]').val(move_function);
                submitCompany($('#btn-add-company'));
                return false;
            }

            // 企業修正
            if (PATH_NAME.includes('Master/Company/edit')) {
                $('#form-update-company').find('[name=move_function]').val(move_function);
                submitCompany($('#btn-update-company'));
                return false;
            }

            // 店舗追加
            if (PATH_NAME.includes('Master/Organization/create')) {
                $('#form-store-organization').find('[name=move_function]').val(move_function);
                submitOrganization($('#btn-add-organization'));
                return false;
            }

            // 店舗修正
            if (PATH_NAME.includes('Master/Organization/edit')) {
                $('#form-update-organization').find('[name=move_function]').val(move_function);
                submitOrganization($('#btn-update-organization'));
                return false;
            }

            // 従業員追加
            if (PATH_NAME.includes('Master/Employee/create')) {
                $('#form-store-employee').find('[name=move_function]').val(move_function);
                submitEmployee($('#btn-add-employee'));
                return false;
            }

            // 従業員修正
            if (PATH_NAME.includes('Master/Employee/edit')) {
                $('#form-update-employee').find('[name=move_function]').val(move_function);
                submitEmployee($('#btn-update-employee'));
                return false;
            }

            // デフォルト出勤時間
            if (PATH_NAME.includes('Setting/defaultShift')) {
                $('#form-default-shift').find('[name=move_function]').val(move_function);
                $('#form-default-shift').find('[name=move_company_id]').val(move_company_id);
                $('#form-default-shift').find('[name=move_organization_id]').val(move_organization_id);
                saveDefaultShift();
                return false;
            }

            // その他
            if (PATH_NAME.includes('Setting/others')) {
                $('#form-setting-others').find('[name=move_function]').val(move_function);
                $('#form-setting-others').find('[name=move_company_id]').val(move_company_id);
                $('#form-setting-others').find('[name=move_organization_id]').val(move_organization_id);
                saveSettingOthers();
                return false;
            }

            // 予測一覧
            if (PATH_NAME.includes('Predict/index')) {
                $('#form-predict').find('[name=move_function]').val(move_function);
                $('#form-predict').find('[name=move_view_date]').val(move_view_date);
                $('#form-predict').find('[name=move_company_id]').val(move_company_id);
                $('#form-predict').find('[name=move_organization_id]').val(move_organization_id);
                savePredict();
                return false;
            }

            // 日次
            if (PATH_NAME.includes('Shift/dayly')) {
                setShiftAll(true, null, 0);
                return false;
            }
        }
    });

    // 保存しないで移動
    $('#btn-move-page').on('click', function() {
        $('#modal-check-move-page').modal('hide');
        if ($(this).hasClass('is-view-mode')) {
            // 自画面変更の場合は解除不要
            switch (Number(move_function)) {
                case move_no_setting_change_company:
                case move_no_setting_change_organization:
                case move_no_predict_change_company:
                case move_no_predict_change_organization:
                case move_no_predict_change_ym:
                case move_no_shift:
                case move_no_monthly:
                case move_no_weekly:
                case move_no_dayly:
                case move_no_dayly_change_company:
                case move_no_dayly_change_organization:
                case move_no_dayly_change_ymd:
                case move_no_dayly_change_type:
                    movePagefromModal();
                    break;
                default:
                    $clicked_object = $(this);
                    $modal_unlock_view_mode.find('[name="unlock_code"]').val('');
                    $modal_unlock_view_mode.modal('show');
            }
        } else {
            movePagefromModal();
        }
    });
});
